export class PushRegistrationService {
  constructor(vapidPublicKey) {
    this.vapidPublicKey = vapidPublicKey
  }
  async registerPush() {
    const registration = await navigator.serviceWorker.register('/service-worker.js')

    await navigator.serviceWorker.ready

    let subscription = await registration.pushManager.getSubscription()

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(this.vapidPublicKey),
      })
      await $.sajax({
        url: '/members/register_push_token',
        type: 'POST',
        data: {
          platform: 'web',
          token: JSON.stringify(subscription),
          meta: { endpoint: subscription.endpoint },
        },
      })
    }

    return subscription
  }

  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  }
}
